/**
 * 控件尺寸管理（large / default / small）
 *
 * 全局统一控制 Element Plus 组件尺寸：App.vue 里用 <el-config-provider :size> 下发，
 * 各列表 / 表单不再写死 size="small"，而是继承这里的统一配置；选择结果存 localStorage。
 */
import { ref } from 'vue'

export type UiSize = 'large' | 'default' | 'small'

const STORAGE_KEY = 'niuren-ui-size'

function readStoredSize(): UiSize {
  const v = localStorage.getItem(STORAGE_KEY)
  return v === 'large' || v === 'small' ? v : 'default'
}

const uiSize = ref<UiSize>(readStoredSize())

export function useUiSize() {
  const setUiSize = (s: UiSize) => {
    uiSize.value = s
    localStorage.setItem(STORAGE_KEY, s)
  }

  return { uiSize, setUiSize }
}
